import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import { getAllSubscriptionByRole } from "../../../services/admin/adminAllApiFn";
import { getCurrentSubscription } from "../../../services/common/CommonApiFn";
import { handleOpenSnackBar } from "../../../utils";
import PlansCard from "./PlansCard";
import { t } from "i18next";

function AllPlans() {
  const [isLoading, setIsLoading] = useState(false);
  const [allSubscription, setAllSubscription] = useState([]);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    if (userData) {
      fetchchedAllSubscriptions();
      fetchchedCurrentSubscription();
    }
  }, [userData]);

  const fetchchedAllSubscriptions = async () => {
    try {
      setIsLoading(true);
      const response = await getAllSubscriptionByRole("company");
      if (response?.data?.status === "success") {
        setAllSubscription(response?.data?.data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchchedCurrentSubscription = async () => {
    try {
      setIsLoading(true);
      const response = await getCurrentSubscription(
        userData?.adminId,
        "company"
      );
      if (response?.data?.status === "success") {
        setCurrentSubscription(response?.data?.data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("allPlans")}
        secondaryHeading={t("packageEditNote")}
      >
        <PlansCard
          data={allSubscription}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          currentSubscription={currentSubscription}
        />
      </AppContainer>
    </>
  );
}

export default AllPlans;
